<template>
  <v-row no-gutters dense class="body-1">
    <v-col cols="12" sm="2">
      <b>{{ compra.id }}</b>
      <div>
        <small>
          código
        </small>
      </div>
    </v-col>
    <v-col cols="12" sm="6">
      <b>{{ compra.company.pessoa.nome }}</b>
      <div>
        <small>
          cliente
        </small>
      </div>
    </v-col>
    <v-col cols="12" sm="2">
      <b>{{ compra.dataCompra | date }}</b>
      <div>
        <small>
          pedido em
        </small>
      </div>
    </v-col>
    <v-col cols="12" sm="2">
      <span class="text--primary--color font-weight-bold">
        {{ compra.total | currency }}
      </span>
      <div>
        <small>
          total
        </small>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    compra: Object,
  },
};
</script>
